export const SEND_TRANSACTION_COMPLETE = 'ANALYTICS/SEND_TRANSACTION_COMPLETE'
export const PAGE_LOADED = 'ANALYTICS/PAGE_LOADED'
export const SEND_TRANSACTION_ERROR = 'ANALYTICS/SEND_TRANSACTION_ERROR'
